// extracted by mini-css-extract-plugin
export default {"container":"InvalidPharmacyWarningMessage_container__X-tm4"};